import OregonCityPageTemplate from "@/pages/oregon-city/CityPageTemplate";
import { salemConfig } from "./data";

export default function SalemPage() {
  return <OregonCityPageTemplate config={salemConfig} />;
}